export const ATTRIBUTE_FILTERS_KEY = "coverFilters";
import {
  CoverListUrlFilters,
  CoverListUrlFiltersEnum,
  CoverListUrlQueryParams
} from "@saleor/cover/urls";
import { CoverFilterInput } from "@saleor/types/globalTypes";
import { createFilterTabUtils, createFilterUtils } from "@saleor/utils/filters";

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CoverListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CoverListUrlQueryParams,
  CoverListUrlFilters
>(CoverListUrlFiltersEnum);

export function getFilterVariables(
  params: CoverListUrlFilters
): CoverFilterInput {
  return {
    search: params.query
  };
}
